var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8390AB",
    d: "M12 2.25c0 0-4.5 6.25-4.5 11.25 0 1.38 1.12 2.5 2.5 2.5h.75v5.5h2.5v-5.5h.75c1.38 0 2.5-1.12 2.5-2.5 0-5-4.5-11.25-4.5-11.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8390AB",
    d: "M7.5 13.5 4.75 16.75 6.5 17.75 7.75 14.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8390AB",
    d: "M16.5 13.5 19.25 16.75 17.5 17.75 16.25 14.25z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.25,
    r: 1.35,
    fill: "#8390AB",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingInactive);
export default __webpack_public_path__ + "static/media/Onboarding-inactive.3923afc692019b7a5156aa9435993c9c.svg";
export { ForwardRef as ReactComponent };